import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo, useState } from 'react';
import { Settings } from '../../../../icons';
import { useDevice } from '../../../../providers/Device';
import { getTestIds } from '../../../../utils/TestIds';
import { DropdownMenu } from '../../../DropdownMenu';
import { IconButton } from '../../../IconButton';
import { Tooltip } from '../../../Tooltip';
import { COLUMNS_PANEL_GAP, SETTINGS_ICON_SIZE } from '../../tableCore/table.constants';
import { ColumnsPanel } from './ColumnsPanel';
import styles from './ColumnsPanel.module.scss';
import { columnsPanelMaxHeight } from './ColumnsPanel.utils';
export function ColumnsPanelTrigger(param) {
    let { columnsPanel, testId } = param;
    const { label, triggerBi } = columnsPanel, panel = _object_without_properties(columnsPanel, [
        "label",
        "triggerBi"
    ]);
    const testIds = useMemo(()=>getTestIds(testId), [
        testId
    ]);
    const { isMobileDevice } = useDevice();
    const [isHovered, setIsHovered] = useState(false);
    const [isPanelOpen, setIsPanelOpen] = useState(false);
    const [panelMaxHeight, setPanelMaxHeight] = useState();
    if (isMobileDevice) return null;
    const changePanelOpen = (open)=>{
        setIsPanelOpen(open);
        // WHY: the open panel's backdrop swallows the gear's mouseleave, so a stale hover would re-show the tooltip on close.
        if (open) setIsHovered(false);
    };
    return /*#__PURE__*/ _jsx(Tooltip, {
        title: label,
        open: isHovered && !isPanelOpen,
        children: /*#__PURE__*/ _jsx("span", {
            className: styles.triggerHost,
            "data-testid": testId,
            onMouseEnter: ()=>setIsHovered(true),
            onMouseLeave: ()=>setIsHovered(false),
            children: /*#__PURE__*/ _jsx(DropdownMenu, {
                gap: COLUMNS_PANEL_GAP,
                onOpenChange: changePanelOpen,
                target: /*#__PURE__*/ _jsx(IconButton, {
                    bi: triggerBi,
                    "aria-label": label,
                    skin: "standard",
                    bordered: true,
                    borderSkin: "subtle",
                    size: "smallMedium",
                    pressed: isPanelOpen,
                    onClick: (event)=>setPanelMaxHeight(columnsPanelMaxHeight({
                            windowHeight: window.innerHeight,
                            triggerBottom: event.currentTarget.getBoundingClientRect().bottom
                        })),
                    className: styles.trigger,
                    testId: testIds.button(),
                    children: /*#__PURE__*/ _jsx(Settings, {
                        size: SETTINGS_ICON_SIZE
                    })
                }),
                testId: testIds.menu(),
                children: /*#__PURE__*/ _jsx(ColumnsPanel, _object_spread_props(_object_spread({}, panel), {
                    maxHeight: panelMaxHeight,
                    testId: testIds.panel()
                }))
            })
        })
    });
}
